







import { Component, Vue, Watch } from "vue-property-decorator";
import { DetailsResponse, Asset } from "../interfaces/meeting/details";
import { getDetails } from "@/services/api/meeting";
import { setClientAuthentication } from "@/services/api/client";
import { AxiosError, AxiosInstance } from "axios";
import { readToken } from "@/services/meeting/token";
import { Roles } from "@/services/socket/meeting";

@Component
export default class VideoPage extends Vue {
  serverDetails: DetailsResponse | null = null;
  apiClient!: AxiosInstance;
  async created() {
    const token =
      new URLSearchParams(window.location.search).get("token") || "";
    const { role } = readToken(token);
    this.apiClient = setClientAuthentication(token);
    // Need to wait for meeting details and creation from backend
    try {
      this.serverDetails = await getDetails(this.apiClient);
    } catch (err) {
      const error = err as AxiosError;
      let message =
        "Your link is not complete - please call your contact for an update.";
      if (error.response?.status === 404) {
        if (Roles.SALES_REP === role) {
          message += "Lead not found.";
        } else if (Roles.CLIENT === role) {
          message += "Meeting not found.";
        }
      } else {
        message = `${message} | ${err} | ${JSON.stringify(err)}`;
      }
      window.alert(message);
    }
  }

  @Watch("serverDetails.assets")
  onAssetsChange(assets: Asset[]) {
    assets
      .filter(asset => asset.endsWith(".sass") || asset.endsWith(".scss"))
      .forEach(asset => {
        /* webpackMode: "lazy" */
        import(`@/assets/specific/${asset}`);
      });
  }

  get loaded() {
    return Boolean(this.serverDetails);
  }

  get stylesheets() {
    return (
      this.serverDetails?.assets?.filter(asset => asset.endsWith(".css")) || []
    );
  }
}
